import {
  ITooltipParams,
  CellClassParams,
  HeaderClassParams,
  ValueGetterParams
} from '@ag-grid-community/core';
import {
  getCustomCellStyle,
  getCustomHeaderStyle
} from 'common/visualizations/views/agGridReact/helpers/TableColumnFormatting';
import { getFieldName } from '../helpers/getFieldName';
import { CustomAgGridContext } from 'common/types/agGrid/context';
import { NULL_GROUPING } from 'common/visualizations/views/agGridReact/Constants';

export const valueGetterFunction = (params: ValueGetterParams) => {
  if (typeof params.data === 'undefined') {
    return;
  }
  const ctx = params.context as CustomAgGridContext;

  const { groupedColumns, showSubTotal } = ctx;
  const field = params.colDef.field ?? '';
  const isGroup = groupedColumns.includes(field);
  if (typeof params.data == 'undefined') {
    return;
  }
  const data = params.data[field];
  if (isGroup && typeof data === 'undefined') {
    return NULL_GROUPING;
  }
  // the condition below checks whether the current field
  // is part of a hierarchy row and a non-hierarchy column
  if (
    params.node?.expanded &&
    params.node?.level < groupedColumns.length &&
    !groupedColumns.includes(field) &&
    showSubTotal
  )
    return;
  return data;
};

export const tooltipValueGetterFunction = (params: ITooltipParams) => {
  const isValueEmpty = !params.value && typeof params.value !== 'boolean';
  if (isValueEmpty) return undefined;
  return params.value;
};

export const cellStyleFunction = (params: CellClassParams) => {
  const ctx = params.context as CustomAgGridContext;
  const { nonStandardAggregations, columnMetadata, columnFormats, showSubTotal, currentRowStripeStyle } = ctx;
  const fieldName = getFieldName(params);
  const columnFormat = columnFormats[fieldName!];
  const localColumnMetadata = columnMetadata.find((c) => c.fieldName === fieldName);

  const customCellStyle = getCustomCellStyle({
    column: localColumnMetadata!,
    nonStandardAggregations,
    columnFormat,
    params,
    showSubTotal,
    currentRowStripeStyle
  });
  return customCellStyle;
};

export const headerClassFunction = (params: HeaderClassParams) => {
  const ctx = params.context as CustomAgGridContext;
  const { columnFormats } = ctx;
  const fieldName = getFieldName(params);
  const columnFormat = columnFormats[fieldName!];

  const customHeaderStyle = getCustomHeaderStyle(columnFormat);

  return [customHeaderStyle, 'ag-grid-header'];
};

export const isNullGrouping = (groupedColumns: string[], value: any, field: string): boolean => {
  const isGroup = groupedColumns.includes(field);
  return isGroup && typeof value === 'undefined';
};
